module.exports = __webpack_public_path__ + "img/arbor.634f96c0.webp";